import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/Login',
			name: 'Login',
			meta: { layout: 'Default' },
			component: () => import('@/components/Login')
		},
		// Administración
		{
			path: '/Registro',
			name: 'Registro',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/Registro')
		},
		{
			path: '/RolesPermisos',
			name: 'RolesPermisos',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/RolesPermisos')
		},
		{
			path: '/EjecutivoEmpresa',
			name: 'EjecutivoEmpresa',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/EjecutivoEmpresa')
		},
		{
			path: '/AgenteEjecutivo',
			name: 'AgenteEjecutivo',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/AgenteEjecutivo')
		},
		{
			path: '/CierreDiario',
			name: 'CierreDiario',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/CierreDiario')
		},
		{
			path: '/IndicadoresDiarios',
			name: 'IndicadoresDiarios',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/IndicadoresDiarios')
		},
		{
			path: '/Proveedores',
			name: 'Proveedores',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/Proveedores')
		},
		{
			path: '/IngresoProveedores',
			name: 'IngresoProveedores',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/IngresoProveedores')
		},
		// contabilidad
		{
			path: '/Contabilidad/Indexa',
			name: 'Contabilidad/Indexa',
			meta: { layout: 'Content' },
			component: () => import('@/components/Contabilidad/Indexa')
		},
		// Home
		{
			path: '/Home',
			name: 'Home',
			meta: { layout: 'Content' },
			component: () => import('@/components/MonitorCuotas')
		},
		{
			path: '/IngresoNegocio',
			name: 'IngresoNegocio',
			meta: { layout: 'Content' },
			component: () => import('@/components/IngresoNegocios')
		},
		{
			path: '/PrintNegocio',
			name: 'PrintNegocio',
			meta: { layout: 'Print' },
			component: () => import('@/components/PrintNegocio')
		},
		{
			path: '/ResumenNegocio',
			name: 'ResumenNegocio',
			meta: { layout: 'Content' },
			component: () => import('@/components/ResumenNegocios')
		},
		// Comercial
		{
			path: '/IngresoClientes',
			name: 'IngresoClientes',
			meta: { layout: 'Content' },
			component: () => import('@/components/Comercial/IngresoClientes')
		},
		{
			path: '/Clientes',
			name: 'Clientes',
			meta: { layout: 'Content' },
			component: () => import('@/components/Comercial/Clientes')
		},
		// FACTURACION
		{
			path: '/Facturacion/Anticipada',
			name: 'FacturacionAnticipada',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/Anticipada')
		},
		{
			path: '/Facturacion/NotasDebito',
			name: 'FacturacionNotasDebito',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/NotasDebito')
		},
		{
			path: '/Facturacion/Mora',
			name: 'FacturacionMora',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/Mora')
		},
		{
			path: '/Facturacion/InterfazFacturacion',
			name: 'InterfazFacturacion',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/InterfazFacturacion')
		},
		{
			path: '/Facturacion/DesAsignacionFacturas',
			name: 'DesAsignacionFacturas',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/DesAsignacionFacturas')
		},
		{
			path: '/AsignacionFacturas',
			name: 'AsignacionFacturas',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/AsignacionFacturas')
		},
		{
			path: '/Facturacion/FinalizarCredito',
			name: 'FinalizarCredito',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/FinalizarCredito')
		},
		// PAGOS
		{
			path: '/Pagos/FacNoEmitida',
			name: 'PagoFacNoEmitida',
			meta: { layout: 'Content' },
			component: () => import('@/components/Pagos/FacNoEmitida')
		},
		{
			path: '/Pagos/FacNoEmitidaMora',
			name: 'PagoFacNoEmitidaMora',
			meta: { layout: 'Content' },
			component: () => import('@/components/Pagos/FacNoEmitidaMora')
		},
		{
			path: '/Pagos/PagoFacEmitida',
			name: 'PagoFacEmitida',
			meta: { layout: 'Content' },
			component: () => import('@/components/Pagos/FacEmitida')
		},
		{
			path: '/Pagos/PagoFacEmitidaMora',
			name: 'PagoFacEmitidaMora',
			meta: { layout: 'Content' },
			component: () => import('@/components/Pagos/FacEmitidaMora')
		},
		{
			path: '/Pagos/Devolucion',
			name: 'Devolucion',
			meta: { layout: 'Content' },
			component: () => import('@/components/Pagos/Devolucion')
		},
		// Informes
		{
			path: '/Informes/PagosyFacturas',
			name: 'InformePagosyFacturas',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/PagosyFacturas')
		},
		{
			path: '/Informes/Comerciales',
			name: 'Informes/Comerciales',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/InformesComerciales')
		},
		{
			path: '/Informes/Devengo',
			name: 'Informes/Devengo',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/Devengo')
		},
		{
			path: '/Informes/CreditosClientes',
			name: 'Informes/CreditosClientes',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/CreditosClientes/CreditosClientes')
		},
		{
			path: '/Informes/Portafolio',
			name: 'Informes/Portafolio',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/Portafolio/Portafolio')
		},
		{
			path: '/Informes/DetallePortafolio',
			name: 'Informes/DetallePortafolio',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/Portafolio/DetallePortafolio')
		},
		{
			path: '/InformeNegociosExcel',
			name: 'InformeNegociosExcel',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/InformeNegociosExcel')
		},
		{
			path: '/InformeCierreMora',
			name: 'InformeCierreMora',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/ResumenCierre/ResumenCierreMora')
		},
		{
			path: 'Informes/DevengoPeru',
			name: 'Informes/DevengoPeru',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/Devengo/DevengoPeru')
		},
		{
			path: '/Informes/RegistroContable',
			name: 'Informes/RegistroContable',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/RegistroContable/indexRegistroContable')
		},
		{
			path: '/Informes/Residual',
			name: 'Informes/Residual',
			meta: { layout: 'Content' },
			component: () => import('@/components/Informes/Residual/index')
		},
		// COMPLIANCE
		{
			path: '/Compliance',
			name: 'Compliance',
			meta: { layout: 'Content' },
			component: () => import('@/components/Compliance/index')
		},
		{
			path: '/Compliance/cartaFianza',
			name: 'Compliance/cartaFianza',
			meta: { layout: 'Content' },
			component: () => import('@/components/Compliance/listVigenciaCartaFianza')
		},
		// OTROS
		{
			path: '/LinkNegocio',
			name: 'LinkNegocio',
			meta: { layout: 'Content' },
			component: () => import('@/components/LinkNegocio')
		},
		{
			path: '/GestionCuota',
			name: 'GestionCuota',
			meta: { layout: 'Content' },
			params: { credito: null, cuota: null, dni: null },
			component: () => import('@/components/GestionCuota')
		},
		{
			path: '/Perfil',
			name: 'Perfil',
			meta: { layout: 'Content' },
			component: () => import('@/components/Usuarios/PerfilUsuario')
		},
		{
			path: '/Admin/Usuario',
			name: 'Admin/Usuario',
			meta: { layout: 'Content' },
			component: () => import('@/components/Administracion/ListaUsuarios')
		},
		{
			path: '/Facturacion/NotaCredito',
			name: 'NotaCredito',
			meta: { layout: 'Content' },
			component: () => import('@/components/Facturacion/NotaCredito')
		},
		{
			path: '/Mantenedor/Parametros',
			name: 'MantenedorParametros',
			meta: { layout: 'Content' },
			component: () => import('@/components/Mantenedor/Parametros')
		},
		{
			path: '/Mantenedor/Listado',
			name: 'Mantenedores',
			meta: { layout: 'Content' },
			component: () => import('@/components/Mantenedor/Mantenedores')
		},
		{
			path: '/Mantenedor/PersonasCargos',
			name: 'MantenedorPersonasCargos',
			meta: { layout: 'Content' },
			component: () => import('@/components/Mantenedor/PersonasCargos')
		},
		{
			path: '/Multipago',
			name: 'Multipago',
			meta: { layout: 'Content' },
			component: () => import('@/components/Multipago/ListPagos')
		},
		{
			path: '/Multipago/PagoDetraccion',
			name: 'MultipagoDetraccion',
			meta: { layout: 'Content' },
			component: () => import('@/components/Multipago/ListCuotasDetraccion')
		},
		{
			path: '/Multipago/PagoCuotas',
			name: 'MultipagoCuotas',
			meta: { layout: 'Content' },
			component: () => import('@/components/Multipago/ListCuotas')
		},
		{
			path: '/Multipago/PagoNotasDebito',
			name: 'MultipagoNotasDebito',
			meta: { layout: 'Content' },
			component: () => import('@/components/Multipago/ListNotasDebito')
		},
		{
			path: '/ImprimirPago',
			name: 'ImprimirPago',
			meta: { layout: 'Print' },
			component: () => import('@/components/Multipago/ImprimirPago')
		},
		{
			path: '/Admin/CuotasPeru',
			name: 'AdminCuotasPeru',
			meta: { layout: 'Content' },
			component: () => import('@/components/AdminPeru/AdminCuotas')
		},
		{
			path: '/Multipago/Chile',
			name: 'MultipagoChile',
			meta: { layout: 'Content' },
			component: () => import('@/components/Multipago/Chile/ListPagos')
		},
		{
			path: '/Multipago/Chile/PagoCuotas',
			name: 'MultipagoChilePagoCuotas',
			meta: { layout: 'Content' },
			component: () => import('@/components/Multipago/Chile/ListCuotas')
		},
		{
			path: '/Multipago/Chile/ImprimirPago',
			name: 'ImprimirPagoChile',
			meta: { layout: 'Print' },
			component: () => import('@/components/Multipago/Chile/ImprimirPago')
		},
		{
			path: '/Inventario/List',
			name: 'InventarioListado',
			meta: { layout: 'Content' },
			component: () => import('@/components/Inventario/ListadoCreditos')
		},
		{
			path: '/Inventario',
			name: 'Inventario',
			meta: { layout: 'Content' },
			component: () => import('@/components/Inventario/ListBienes')
		},
		{
			path: '*',
			redirect: '/Login'
		}
	]
})

router.beforeEach((to, from, next) => {
	store.dispatch('fetchAccessToken')
	if (store.state.accessToken) {
		store.dispatch('fetchAccessMenu')
	}
	if (to.fullPath === '/ResumenNegocio') {
		if (!store.state.accessToken) {
			next('/Login')
		}
	}
	if (to.fullPath === '/Login') {
		if (store.state.accessToken) {
			next('/ResumenNegocio')
		}
	}
	next()
})

router.onError((error) => {
	if (/loading chunk \d+ failed/i.test(error.message)) {
		window.location.reload()
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js